import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { RenderSVG } from '../../../common/render-svg';
import Dark from './assets/dark.svg';
import Light from './assets/light.svg';
export var SpotError = function SpotError(props) {
  return /*#__PURE__*/React.createElement(RenderSVG, _extends({
    src: Light,
    srcDark: Dark
  }, props));
};